/**
 * Entity - Benefits data model
 */
import livresImage from '../../../../public/livres.png';
import livreOuvertImage from '../../../../public/livre-ouvert.png';
import communauteImage from '../../../../public/communaute.png';

// Modern SVG Icons as React components
const BookIcon = () => (
  <img 
    src={livreOuvertImage} 
    alt="Open book" 
    style={{
      width: '64px',
      height: '64px',
      filter: 'invert(38%) sepia(18%) saturate(1676%) hue-rotate(101deg) brightness(95%) contrast(88%)',
      objectFit: 'contain'
    }}
  />
);

const ExchangeIcon = () => (
  <img 
    src={livresImage} 
    alt="Books exchange" 
    style={{
      width: '64px',
      height: '64px',
      filter: 'invert(38%) sepia(18%) saturate(1676%) hue-rotate(101deg) brightness(95%) contrast(88%)',
      objectFit: 'contain'
    }}
  />
);

const CommunityIcon = () => (
  <img 
    src={communauteImage} 
    alt="Community" 
    style={{
      width: '64px',
      height: '64px',
      filter: 'invert(38%) sepia(18%) saturate(1676%) hue-rotate(101deg) brightness(95%) contrast(88%)',
      objectFit: 'contain'
    }}
  />
);

export const benefitsData = [
  {
    id: 1,
    title: 'Une plateforme pensée pour les lecteurs',
    description:
      'Contrairement aux marketplaces généralistes, Bookiner est conçue exclusivement pour les amoureux des livres.',
    icon: <BookIcon />,
  },
  {
    id: 2,
    title: 'Achetez, vendez et découvrez facilement',
    description:
      "Trouvez rapidement des livres d'occasion, revendez ceux que vous n'utilisez plus et découvrez de nouvelles lectures adaptées à vos goûts.",
    icon: <ExchangeIcon />,
  },
  {
    id: 3,
    title: 'Une communauté avant tout',
    description:
      'Bookiner vise à créer une véritable communauté de lecteurs, avec des recommandations intelligentes et des échanges autour des livres.',
    icon: <CommunityIcon />,
  },
];
